import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { first } from 'rxjs/operators';
import { LayoutService } from 'src/app/core/data-sources/layout.service';
import { ActionService } from 'src/app/core/services/action.service';
import { ErrorsEnum, ErrorService } from 'src/app/core/services/error.service';
import { toExcelFormat } from 'src/app/helpers/format-position';
import { ConfirmModalComponent } from 'src/app/modals/confirm-modal/confirm-modal.component';

@Component({
  selector: 'app-setup-pigeonhole',
  templateUrl: './setup-pigeonhole.component.html',
  styleUrls: ['./setup-pigeonhole.component.scss']
})
export class SetupPigeonholeComponent implements OnInit {

  map;
  selectedPositionIds = new Set<string>();
  selectedPositions = [];

  constructor(
    private layoutService: LayoutService,
    private actionService: ActionService,
    private errorService: ErrorService,
    public dialog: MatDialog,
    private router: Router
  ) { }

  async ngOnInit() {
    await this.loadData();
    this.initSelectedPigeonholes();
  }

  async loadData() {
    return this.layoutService.getMap().then(res => {
      this.map = res;
      return res;
    });
  }
  
  positionSelected(position) {
    if (this.selectedPositionIds.has(position.rfId)) {
      this.selectedPositionIds.delete(position.rfId);
    } else {
      this.selectedPositionIds.add(position.rfId);
    }
    this.selectedPositionIds = new Set<string>(this.selectedPositionIds);
    this.updateSelectedPositions();
  }

  getPositionByRfId(rfId) {
    for (const p of this.map) {
      if (p.rfId === rfId) { 
        return p; 
      }
    }
    return null;
  }

  async toFinish() {
    await this.router.navigate(['/setup-finish']);
  }

  async toSetup() {
    await this.router.navigate(['/setup']);
  }

  async save() {
    const message = 'Deseja salvar as alterações realizadas?';

    const dialogRef = this.dialog.open(ConfirmModalComponent, {
      panelClass: 'confirm-modal',
      autoFocus: false,
      data: { label: message }
    });

    return dialogRef.afterClosed().pipe(first()).subscribe(async (res) => {
      if (res === 'SUBMITTED') {
        try {
          await this.actionService.editPositionToPigeonhole({ rfids: Array.from(this.selectedPositionIds) });
          await this.loadData();
          this.initSelectedPigeonholes();
        } catch (err) {
          this.handleSaveError(err);
        }
      }
    });
  }

  private handleSaveError(err: any) {
    const error = err?.error?.body || err?.error || err;
    const type = error?.type;
    let message = 'Algo deu errado. Tente novamente.';
    const formatPos = (x, y) => {
      if (this.map) {
        const found = this.map.find(p => p && p.x === x && p.y === y);
        if (found && found.alias) {
          return found.alias;
        }
      }
      return toExcelFormat(x, y);
    };
    if (type === ErrorsEnum.GROUND_POSITION_WITH_TASK) {
      const details = error.details;
      const coords = details ? details.map(d => formatPos(d.x, d.y)).join(', ') : '';
      message = `Não foi possível salvar. Estas posições têm tarefa ativa ${coords ? ': ' + coords : '.'}`;
    } else if (type === ErrorsEnum.GROUND_POSITION_WITH_PALLET) {
      const positions = error?.details?.positions;
      const coords = positions ? positions.map(d => formatPos(d.x, d.y)).join(', ') : '';
      message = `Não foi possível salvar. Existem paletes nas posições ${coords ? ': ' + coords : '.'}`;
    } else if (type === ErrorsEnum.GROUND_POSITION_NOT_FOUND) {
      const details = error.details;
      const ids = details ? details.join(', ') : details || '';
      message = `Não foi possível salvar. Posições não encontradas ${ids ? ': ' + ids : '.'}`;
    } else if (error?.message) {
      message = error.message;
    }
    this.errorService.openErrorSnackBarWithCustomMessage(message);
  }

  cancel() {
    if (!this.map) return;
    for (const id of Array.from(this.selectedPositionIds)) {
      const p = this.getPositionByRfId(id);
      if (!p || p.type !== 'PIGEONHOLE') {
        this.selectedPositionIds.delete(id);
      }
    }
    this.selectedPositionIds = new Set<string>(this.selectedPositionIds);
    this.updateSelectedPositions();
  }

  updateSelectedPositions() {
    this.selectedPositions = this.map ? this.map.filter(p => this.selectedPositionIds.has(p.rfId)) : [];
  }

  initSelectedPigeonholes() {
    if (!this.map) return;
    const pigeonholes = this.map.filter(p => p && p.type === 'PIGEONHOLE');
    if (pigeonholes.length > 0) {
      this.selectedPositions = pigeonholes;
      this.selectedPositionIds = new Set<string>(pigeonholes.map(p => p.rfId));
    }
  }

  removeFromList(position) {
    this.selectedPositionIds.delete(position.rfId);
    this.selectedPositionIds = new Set<string>(this.selectedPositionIds);
    this.updateSelectedPositions();
  }


}
